import { addBusinessDays, format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { formatDate, formatWeekday } from './Formats';

export const calculateDeliveryDate = (orderDate, deliveryTime) => {
    // Convert deliveryTime string to number
    let daysToAdd;
    
    if (deliveryTime.includes('a')) {
        // Handle cases like "1 a 2"
        const numbers = deliveryTime.match(/\d+/g);
        if (numbers) {
            // Get the larger number
            daysToAdd = Math.max(...numbers.map(Number));
        } else {
            daysToAdd = 0;
        }
    } else {
        // Handle single number cases
        daysToAdd = parseInt(deliveryTime) || 0;
    }

    // Create a new date object
    const deliveryDate = new Date(orderDate);
    
    // Add business days (skipping weekends)
    let addedDays = 0;
    while (addedDays < daysToAdd) {
        deliveryDate.setDate(deliveryDate.getDate() + 1);
        // Skip weekends (0 = Sunday, 6 = Saturday)
        if (deliveryDate.getDay() !== 0 && deliveryDate.getDay() !== 6) {
            addedDays++;
        }
    }

    return `${formatDate(deliveryDate, true)}, ${formatWeekday(deliveryDate)}`;
};